module.exports = __webpack_public_path__ + "p3_img3.jpg?dc07ee88fb492c48174c7a0ab6b7a76e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img3.jpg
// module id = 119
// module chunks = 0